import React from "react";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

function QuestionTypeItem({
  type,
  handleItemClick,
  isSelected,
  icon,
  title,
  manualUrl,
}) {
  return (
    <MenuItem
      onClick={() => handleItemClick(type)}
      selected={isSelected}
      sx={{ textAlign: "left"}}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{title}</ListItemText>
      <IconButton size="small" onClick={() => window.open(manualUrl, "_blank")}>
        <HelpOutlineIcon fontSize="small" />
      </IconButton>
    </MenuItem>
  );
}

export default QuestionTypeItem;
